import {createStore, applyMiddleware} from 'redux';
import {thunk as Thunk} from 'redux-thunk';
import Reducers from '../reducers';

const store = createStore(Reducers, applyMiddleware(Thunk));
export const dispatch = store.dispatch;
export const getState = store.getState;

export default store;